import {
    BlockConditionOperator,
    BlockConditionProperty,
    type TConditionalBlockCheck,
    type TVariantBlockData,
    type TGetCurrentPropertyValue
} from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const checkOperation = (op: BlockConditionOperator, expected: any, actual: any) => {
    switch (op) {
        case BlockConditionOperator.EQ:
            return expected === actual;
        default:
            return false;
    }
};

const CONDITIONAL_OPERATORS: Record<BlockConditionProperty, TConditionalBlockCheck> = {
    [BlockConditionProperty.PlayerCountry]: <T = string>(
        op: BlockConditionOperator,
        expected: T,
        actual: T
    ) => {
        return checkOperation(op, expected, actual);
    }
};

export const shouldRender = (
    variant: TVariantBlockData | null | undefined = undefined,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getCurrentValueOfProperty: TGetCurrentPropertyValue
): boolean => {
    if (!variant) {
        return true;
    }
    const { condition } = variant;
    const { operator, property, value } = condition;
    const fn = CONDITIONAL_OPERATORS[property];

    if (!fn) {
        // treat as false if the property is not supported
        return false;
    }
    try {
        return fn(operator, value, getCurrentValueOfProperty(property));
    } catch (e) {
        console.error(e);
        return false;
    }
};
